
$(function() {
    const swiper1 = new Swiper('.swiper', {
        loop: true,
        effect: 'fade',
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
    });

    let array_img = [];
    $('#product-img-slider li[class*="swiper-item-image"]').each(function() {
        let array_img_tmp = {};
        array_img_tmp.number = $(this).data('swiper-slide-index');
        array_img_tmp.url = $(this).children('img').attr('src');
        array_img.push(array_img_tmp);
        // console.log($(this).data('swiper-slide-index'));
        //array_img.push($(this).children('img').attr('src'));
    });

    let new_array_img = array_img.filter((element, index, self) => 
    self.findIndex(e => 
        e.number === element.number &&
        e.url === element.url
        ) === index
    );

    new_array_img.sort(function(a, b) {
        return a.number - b.number;
    });

    new_array_img.forEach(function( value ) {
        let number = value["number"] + 1,
        url = value["url"],
        width = $('#swiper-pagination span:nth-child(' + number + ')').width();
        $('#swiper-pagination span:nth-child(' + number + ')').css({"background-image": "url(" + url + ")", "height": width});
    });

    function PagenationPosition(){
        let pagination_height = $('#swiper-pagination').height() / 2;
        let css_top_value = "calc(50% - " + pagination_height + "px)";
        $('.swiper-button-prev, .swiper-button-next').css("top", css_top_value);
    }
    PagenationPosition()

    function HeightAdjust(){
        let h = $('#swiper-pagination span'),
        change_value = $('#swiper-pagination span:first').width();
        $(h).css('height', change_value);
    }

    let _resizeEvent;  // タイマーのIDを保存する変数
    window.onresize = function(){  // リサイズイベントが発生したら無名関数を呼び出す
        clearTimeout(_resizeEvent);  // 呼び出される度にsetTimeout関数を削除してリセットする
        _resizeEvent = setTimeout(function(){
            HeightAdjust();
            PagenationPosition();
        }, 200);  // 200msを待ち時間として設定
    };

    $(document).ready(function(){
        $('main').addClass('loaded');
        
        //前に戻る
        (function(){
            let ans, //1つ前のページが同一ドメインかどうかを判定する
            bs  = false, //history.back()がうまく動いているかどうかを判別する
            ref = document.referrer;//サイトの経由（リファラー）を判別する
     
     
            //onbeforeunloadは一応opera用、unloadで他ブラウザは動くはず
            $(window).bind("unload beforeunload",function(){
                bs = true;
            });
     
            //1つ前のページが同一ドメインかどうか
            re = new RegExp(location.hostname,"i");
            if(ref.match(re)){
                ans = true;
            }else{
                ans = false;
            }
     
            //.returnはaタグに仕込むクラスです。適宜書き換えを
            $('#page-back').bind("click",function(){
                    var that = this;
                if(ans){　//もし同一ドメインだったらhistory.back();
                    history.back();
                    setTimeout(function(){
                        if(!bs){
                            location.href = $(that).attr("href");　//JS無効だったらhrefに設定したリンクへ
                        }
                    },100);
                }else{　//それ以外もhrefに設定したリンクへ
                        location.href = $(this).attr("href");
                    }
                return false;
            });
        })();
    });
});